var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('r-table',_vm._b({ref:"table",attrs:{"no-data-text":"Sin nota de debitos.","no-remove":"","no-search":"","remind-key":"purchase-debit-note-list"},on:{"detail":_vm.submitDetail,"remove":_vm.submitRemove}},'r-table',_vm.tableProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }